
import React, { useEffect, useState, useContext } from "react";
import { CartContext } from "../../../contexts/cartContext";
import { CurrencyContext } from "../../../contexts/currencyContext"; // Import context
import { useNavigate } from "react-router-dom";
const CheckoutPayment = () => {

    const [activeTab, setActiveTab] = useState('tab1');
    const { cart, updateCart } = useContext(CartContext);
    const [cartData, setCartData] = useState([]);
    const [summary, setSummary] = useState({ mrp: 0, discount: 0, gstAmount: 0, subTotal: 0, shipping: 0, shippingGST: 0, totalAmount: 0, });
    const { currencyContxt } = useContext(CurrencyContext); // Use context
    const [loading, setLoading] = useState(false); // Loading state
    const [error, setError] = useState(null); // Error state

    const navigate = useNavigate();

    const [selectedOption, setSelectedOption] = useState(null);
    const handleRadioChange = (event) => {
        setSelectedOption(event.target.id); // Update the selected option state
      };

      const userInfo = JSON.parse(localStorage.getItem('user-info'));
    const handlePayment = async () => {

        console.log("Selected Gateway Option:", selectedOption); // Log to check the value and type
        
/* 
        if(selectedOption === "1")
        {
            const options = {
                key: process.env.REACT_APP_RAZORPAY_KEY_ID, // Your Razorpay key id
                amount: summary.totalAmount * 100, // Amount in paise
                currency: currencyContxt.currency,
                name: 'IndiGalleria',
                description: 'Purchase Description',
                handler: (response) => {
                    console.log(response);
                    // Handle successful payment here
                },
                prefill: {
                    name: 'Customer Name',
                    email: 'customer@example.com',
                    contact: '9191919191',
                },
                theme: {
                    color: '#F37254'
                }
            };
    
            const razorpay = new window.Razorpay(options);
            razorpay.open();
        } else if (selectedOption === "2"){

            alert("PayPal");
        } else if (selectedOption === "3"){
            
            // PayU logic
        try {
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const data = {
                key: process.env.PAYU_KEY, // Replace with your actual key
                txnid: `txn_${Date.now()}`,
                amount: summary.totalAmount.toString(),
                productinfo: "Your Product Description",
                firstname: userInfo?.name || "Customer",
                email: userInfo?.email || "customer@example.com",
                phone: userInfo?.phone || "9191919191",
                surl: process.env.SUCCESS_URL, // Success URL
                furl: process.env.FAILURE_URL, // Failure URL
            };

            // Get the hash from the backend
            const response = await fetch("https://igapi.heuristticminds.com/api/getPayUHash", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(data),
            });
            const result = await response.json();

            if (result.hash) {
                // Redirect to PayU form
                const form = document.createElement("form");
                form.method = "POST";
                form.action = "https://sandboxsecure.payu.in/_payment"; // Use live URL in production

                for (const key in data) {
                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = key;
                    input.value = data[key];
                    form.appendChild(input);
                }

                const hashInput = document.createElement("input");
                hashInput.type = "hidden";
                hashInput.name = "hash";
                hashInput.value = result.hash;
                form.appendChild(hashInput);

                document.body.appendChild(form);
                form.submit();
            } else {
                alert("Error generating hash");
            }
        } catch (error) {
            console.error("PayU Error:", error);
        }
        } else {
            alert("No valid payment option selected");
        }     */
        
            saveOrderDetails();
    };

    const saveOrderDetails = async () => {
        
        const formData = {

            "user_id": userInfo.buyer_id,
            "mrp": parseFloat(summary.mrp),
            "discount": parseFloat(summary.discount),
            "gstPrice": parseFloat(summary.gstAmount),
            "shippingCost": parseFloat(summary.shipping),
            "shippingCostGST" : parseFloat(summary.shippingGST),
            "currency_id": currencyContxt.id,
            "paymentModeID": 1,
            "paymentStatusType": 1,
            "orderStatusType": 1,

            
        };
        try {
            
            // Make the API call to save the form data
            const response = await fetch('https://igapi.heuristticminds.com/api/OrderList/Add-SaveOrderDetails', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });
            if (response.ok) {
                debugger;
                //const confirmed = window.confirm("Order Saved Successfully !!!");
                const contentType = response.headers.get('content-type');
                    let responseData;

                    if (contentType && contentType.indexOf('application/json') !== -1) {
                        // Parse the JSON response
                        responseData = await response.json();
                    } else {
                        // Parse the text response
                        const responseText = await response.text();
                        responseData = { message: responseText };
                    }
                    let orderID = '';
                    orderID = responseData.newlyCreatedOrderID; // Assuming your API returns productId upon successful creation
                navigate(`/paymentSuccess/${orderID}`);

            } else {
                // Handle error cases
                console.error('Error saving form data:', response.statusText);
            }
        } catch (error) {
            console.error('Error saving form data:', error);
        }
    };

    const tabContents = {
        tab1: <>
            <h5>Select one of below listed payment gateway</h5>
            <div className="p-4">
            <ul className="list1">
        <li>
          <div className="pg_box">
            <input
              type="radio"
              id="1"
              name="pgOption"
              checked={selectedOption === "1"}
              onChange={handleRadioChange}
            />
            <label htmlFor="1">
              <img src="../../../images/razorpay.png" alt="Razorpay Payment Gateway" />
            </label>
          </div>
        </li>
        <li>
          <div className="pg_box">
            <input
              type="radio"
              id="2"
              name="pgOption"
              checked={selectedOption === "2"}
              onChange={handleRadioChange}
            />
            <label htmlFor="2">
              <img src="../../../images/paypal.png" alt="PayPal Payment Gateway" />
            </label>
          </div>
        </li>
        <li>
          <div className="pg_box">
            <input
              type="radio"
              id="3"
              name="pgOption"
              checked={selectedOption === "3"}
              onChange={handleRadioChange}
            />
            <label htmlFor="3">
              <img src="../../../images/payu.png" alt="PayU Payment Gateway" />
            </label>
          </div>
        </li>
      </ul>
                <button className="btn2 bg-primary text-white border-0 mt-3" onClick={handlePayment} disabled={!selectedOption}>Continue</button>
            </div>

        </>,
        tab2: <>
            <h5>UPI Details</h5>
            <div className="p-4 text-center">
                <small>Scan and pay now</small>
                <div className="mt-3">
                    <img src="../images/payment/qr-code.svg" width="150" />
                </div>
            </div>
        </>
    };



    //Order Summary Starts

    // Function to fetch Cart List data
    const fetchCartListData = async () => {
        setLoading(true); // Start loading
        //const userInfo = JSON.parse(localStorage.getItem('user-info'));
        if (userInfo && userInfo.buyer_id) {
            try {
                const cartlistResponse = await fetch(`https://igapi.heuristticminds.com/api/CartList/Get-GetCartListByUserID?user_id=${userInfo.buyer_id}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${userInfo.token}`,  // Pass user token if required
                    },
                });
                if (!cartlistResponse.ok) {
                    throw new Error('Network response was not ok');
                }

                const cartlistData = await cartlistResponse.json();
                setCartData(cartlistData);
                updateCart(cartlistData); // Update context
                calculateSummary(cartlistData); // Calculate summary
            } catch (error) {
                console.error("Error fetching wishlist data:", error);
            } finally {
                setLoading(false); // End loading
            }
        } else {
            // Fallback to localStorage if user is not logged in
            const localCartlist = localStorage.getItem('cart');
            if (localCartlist) {
                const parsedCart = JSON.parse(localCartlist);
                setCartData(parsedCart);
                calculateSummary(parsedCart); // Calculate summary
            }
            setLoading(false); // End loading if no user info
        }
    };

    // Calculate price summary
    const calculateSummary = (cartData) => {
        let mrp = cartData.reduce((acc, item) => acc + (item.mrp || 0), 0);
        let discount = cartData.reduce((acc, item) => acc + (item.discount || 0), 0);
        let gstAmount = cartData.reduce((acc, item) => acc + (item.gst || 0), 0); // Assuming GST amount from API
        let subTotal = cartData.reduce((acc, item) => acc + ((item.mrp || 0) - (item.discount || 0) + (item.gst || 0)), 0);
        // Check the currency type and apply the appropriate shipping cost
        let shipping = 0;
        let shippingGST = 0;
        if (currencyContxt.currency === 'INR') {
            shipping = cartData.reduce((acc, item) => acc + (item.shippingINR || 0), 0);
            shippingGST = cartData.reduce((acc, item) => acc + ((item.shippingINR || 0) * (item.shippingGST || 0) / 100), 0);
        } else {
            shipping = cartData.reduce((acc, item) => acc + (item.shippingOthers || 0), 0);
            shippingGST = cartData.reduce((acc, item) => acc + ((item.shippingOthers || 0) * (item.shippingGST || 0) / 100), 0);
        }
        const totalAmount = (mrp - discount + gstAmount + shipping + shippingGST).toFixed(2);

        setSummary({
            mrp: mrp.toFixed(2),
            discount: discount.toFixed(2),
            gstAmount: gstAmount.toFixed(2),
            subTotal: subTotal.toFixed(2),
            shipping: shipping.toFixed(2),
            shippingGST: shippingGST.toFixed(2),
            totalAmount,
        });
        return {
            mrp,
            discount,
            gstAmount,
            subTotal,
            shipping,
            shippingGST,
            totalAmount,
        };
    };

    useEffect(() => {
        if (cart.length > 0) {
            calculateSummary(cart);
        }
    }, [cart, currencyContxt]); // Recalculate when cart or currency changes

    useEffect(() => {
        fetchCartListData();
    }, []);


    //Order Summary Ends




    return (
        <>
            <div className="pt-3 pb-3 mb-3 border-bottom">
                <div className="container">
                    <a className="logo" href="/"><img src="../../../images/logo-icon.png" alt="" /><span>Indi<span>G</span>alleria</span></a>
                </div>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-sm-8">
                        <div className="mb-4 pb-3">
                            <div className="fs-4 mb-3">Payment Method</div>
                            <div className="vertical-tabs-container">
                                <div className="vertical-tabs">
                                    <button className={`tab-button ${activeTab === 'tab1' ? 'active' : ''}`} onClick={() => setActiveTab('tab1')}>
                                        <img src="../images/payment/credit.svg" /> Credit / Debit Card
                                    </button>
                                    <button className={`tab-button ${activeTab === 'tab2' ? 'active' : ''}`} onClick={() => setActiveTab('tab2')}>
                                        <img src="../images/payment/upi.svg" /> UPI
                                    </button>
                                </div>
                                <div className="tab-content">
                                    {tabContents[activeTab]}
                                </div>
                            </div>
                        </div>


                    </div>
                    <div className="col-sm-4 ps-5 mb-5">
                        <div className="bg-light p-3 border">
                            <div className="">
                                <div className="fs-4">Order Summary</div>
                                <div className="bg-light p-3 border">
                                    <div className="pricetype">
                                        Artwork MRP <span> {(summary.mrp / currencyContxt.value).toFixed(2)}</span>
                                    </div>
                                    <div className="pricetype">
                                        Discount<span>{(summary.discount / currencyContxt.value).toFixed(2)}</span>
                                    </div>
                                    <div className="pricetype">
                                        GST<span>{(summary.gstAmount / currencyContxt.value).toFixed(2)}</span>
                                    </div>
                                    <div className="pricetype">
                                        Sub Total<span>{(summary.subTotal / currencyContxt.value).toFixed(2)}</span>
                                    </div>
                                    <div className="pricetype">
                                        Shipping Fee<span>{(summary.shipping / currencyContxt.value).toFixed(2)}</span>
                                    </div>
                                    <div className="pricetype">
                                        Shipping GST<span>{(summary.shippingGST / currencyContxt.value).toFixed(2)}</span>
                                    </div>
                                    <div className="pricetype">
                                        <b> Total Amount</b><span><b>
                                            {currencyContxt.icon}&nbsp;{(summary.totalAmount / currencyContxt.value).toFixed(2)}
                                        </b></span>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div >
            <footer>
                <div className="container">
                    <ul className="pay_icon">
                        <li><img src="../images/payment/Mastercard.svg" /></li>
                        <li><img src="../images/payment/visa.svg" /></li>
                        <li><img src="../images/payment/visa-electron.svg" /></li>
                    </ul>
                    <ul className="ftr_link">
                        <li><a href="#">+91-9555511765</a></li>
                        <li><a href="#">Home</a></li>
                        <li><a href="#">About Company</a></li>
                    </ul>
                    <div className="copyright text-center">
                        <span className="bi bi-c-circle"></span> 2017-2024 IndiGalleria. All rights reserved.
                    </div>
                </div>
            </footer>
        </>
    )
}

export default CheckoutPayment;